import React from 'react';
import PropTypes from 'prop-types';
import ResponseTap from '../response-tap';
import { Title } from '../shop-info/styles';
import { Paragraph } from './styles';
import { sanitizePhoneNumber, phoneNumberURI } from '../../utils/phone-number';

const ContactUs = ({
  title = 'Contact us',
  email,
  phone,
  responseTapClass = '',
}) => (
  <>
    {title ? <Title>{title}</Title> : null}
    {phone ? (
      <Paragraph>
        <a
          target="_blank"
          rel="noreferrer noopener"
          href={phoneNumberURI(phone)}
          aria-label={`Contact the shop at ${sanitizePhoneNumber(phone)}`}
        >
          {responseTapClass ? (
            <ResponseTap rtId={responseTapClass}>{phone}</ResponseTap>
          ) : (
            phone
          )}
        </a>
      </Paragraph>
    ) : null}
    {email ? (
      <Paragraph>
        <a
          target="_blank"
          rel="noreferrer noopener"
          href={`mailto:${email}`}
          aria-label={`Email the shop at ${email}`}
        >
          {email}
        </a>
      </Paragraph>
    ) : null}
  </>
);

ContactUs.propTypes = {
  title: PropTypes.string,
  phone: PropTypes.string,
  email: PropTypes.string,
  responseTapClass: PropTypes.string,
};

export default ContactUs;
